import Component from '../inherited/Component'

export default class InternalNavBar extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._list = this._elem.querySelector('[data-internal-nav-list]')
    this._items = this._elem.querySelectorAll('[data-nav-item]')
    this._height = parseFloat(this._elem.getBoundingClientRect().height)
    this._offset = this._height
    this._itemTargets = []
    this._lastScrollY = 0
    this._negativeOffset = 0
  }

  mount () {

    let headerIsSticky = document.querySelector('sticky-header')
    if(headerIsSticky) {
        let headerHeight = headerIsSticky.getBoundingClientRect().height
        this._elem.closest('.shopify-section').style.top = `${headerHeight}px`
        this._negativeOffset = headerHeight
    }
    
    for (let item of this._items) {
      let id = item.getAttribute('href')
      let targets = document.querySelectorAll(id)
      if (targets) {
        this._itemTargets.push({
          trigger: item,
          targets: targets
        })
      }

      item.addEventListener('click', e => {
        e.preventDefault()
        window.location.hash = id
        window.scrollTo({
          top: window.pageYOffset + targets[0].getBoundingClientRect().top - this._offset,
          behavior: 'smooth'
        })
      })
    }

    if (window.location.hash) {
      for (let item of this._items) {
        if (item.getAttribute('href') === window.location.hash) {
          item.click()
          break
        }
      }
    }
    window.addEventListener('scroll', e => {
      this._setActive()
    }, { passive: true })
    this._setActive()
  }

  _setActive () {
    let haveSetActive = false

    for (let targetPair of this._itemTargets) {
      targetPair.trigger.classList.remove('active')

      for (let target of targetPair.targets) {
        let offsetTop = target.getBoundingClientRect().top
        let offsetBottom = target.getBoundingClientRect().bottom

        if ((offsetTop - this._negativeOffset - this._offset) <= 0 && (offsetBottom - this._negativeOffset - this._offset) >= 0) {
          targetPair.trigger.classList.add('active')
          haveSetActive = true
          break
        }
      }
    }

    let offsetTop = this._itemTargets[0].targets[0].offsetTop
    if (!haveSetActive && window.scrollY < offsetTop) {
      this._itemTargets[0].trigger.classList.add('active')
    }
  }
}